let accessToken = "";
let sessionInfo = null;
let refreshHandler = null;
let reauthenticationHandler = null;
let sessionExpiredHandler = null;
let refreshPromise = null;

export function getAccessToken() {
  return accessToken;
}

export function setAccessToken(value) {
  accessToken = String(value || "");
}

export function getSessionInfo() {
  return sessionInfo;
}

export function setSessionInfo(value) {
  sessionInfo = value || null;
}

export function clearRuntimeSession() {
  accessToken = "";
  sessionInfo = null;
}

export function registerRefreshHandler(handler) {
  refreshHandler = typeof handler === "function" ? handler : null;
}

export async function refreshAccessToken() {
  if (!refreshHandler) return "";

  if (!refreshPromise) {
    refreshPromise = Promise.resolve()
      .then(() => refreshHandler())
      .finally(() => {
        refreshPromise = null;
      });
  }

  return refreshPromise;
}

export function registerReauthenticationHandler(handler) {
  reauthenticationHandler = typeof handler === "function" ? handler : null;
}

export async function requestReauthentication(context = {}) {
  if (!reauthenticationHandler) return false;
  return reauthenticationHandler(context);
}

export function registerSessionExpiredHandler(handler) {
  sessionExpiredHandler = typeof handler === "function" ? handler : null;
}

export function notifySessionExpired(reason = "session_expired") {
  sessionExpiredHandler?.(reason);
}
